// MakeaLinkPopup.jsx

import React, { useEffect, useRef, useState } from 'react';
import useUserStore from '../store/userStore';
import useCurrentAssetStore from '../store/currentAssetStore';
import { useRouter } from 'next/router'; // Changed from react-router-dom

const MakeaLinkPopup = () => {
  const showMakeaLinkPopup = useUserStore((state) => state.showMakeaLinkPopup);
  const closeMakeaLinkPopup = useUserStore((state) => state.closeMakeaLinkPopup);
  const panelRef = useRef(null);

  const collection = useCurrentAssetStore((state) => state.collection);
  const slug = useCurrentAssetStore((state) => state.slug);
  const baseURL = useCurrentAssetStore((state) => state.link); 

  const [copied, setCopied] = useState(false);
  const router = useRouter(); // Changed from useNavigate

  const handleOverlayClick = () => {
    closeMakeaLinkPopup();
  };

  const handlePanelClick = (e) => {
    e.stopPropagation();
  };

  const handleCopyHTML = () => {
    const attributionHTML = `<a href="${baseURL}" target="_blank" rel="noopener">Icons</a> by <a href="https://davooda.com" target="_blank" rel="noopener">davooda.com</a>`;
    navigator.clipboard.writeText(attributionHTML).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1000);
    });
  };

  const handleHowToAttribute = (e) => {
    e.preventDefault();
    router.push('/how-to-attribute'); // Changed from navigate
    closeMakeaLinkPopup();
  };

  useEffect(() => {
    if (showMakeaLinkPopup) {
      requestAnimationFrame(() => {
        if (panelRef.current) {
          panelRef.current.style.transform = 'translateX(0)';
        }
      });
    }
  }, [showMakeaLinkPopup]);

  if (!showMakeaLinkPopup) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      zIndex: 9999,
      background: 'rgba(0,0,0,0.5)',
      fontFamily: "'Poppins', sans-serif",
      transition: 'opacity 0.3s ease',
      overflow: 'hidden',
      cursor: 'pointer'
    }} onClick={handleOverlayClick}>
      <div
        style={{
          background: '#fff',
          width: '600px',
          maxWidth: '90%',
          height: '100%',
          boxShadow: '2px 0 10px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column',
          padding: '80px',
          boxSizing: 'border-box',
          transform: 'translateX(-100%)',
          transition: 'transform 0.3s ease',
          cursor: 'auto',
          position: 'relative',
          ...(showMakeaLinkPopup ? {transform: 'translateX(0)'} : {})
        }}
        onClick={handlePanelClick}
        ref={panelRef}
      >
        <img
          src="/images/close_cross_big.svg"
          alt="Close"
          style={{
            position: 'absolute',
            top: '30px',
            right: '30px',
            cursor: 'pointer',
            width: '20px',
            height: '20px'
          }}
          onClick={closeMakeaLinkPopup}
        />
        
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          transform: 'translateY(-100px)'
        }}>
          <h2 style={{
            margin: 0,
            marginBottom: '20px',
            fontWeight: '700',
            fontSize: '24px',
            color: '#111',
            fontFamily: "'Poppins', sans-serif"
          }}>Please credit these icons</h2>
          <p style={{
            fontSize: '16px',
            color: '#333',
            marginBottom: '20px',
            lineHeight: '1.4'
          }}>
            When using these icons, please mention the author and source. Copy the code below and add it to your project.
          </p>
          
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '14px 24px',
              border: '1px solid #333',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background 0.3s ease, color 0.3s ease, border 0.3s ease',
              fontFamily: "'Poppins', sans-serif",
              minWidth: '220px',
              gap: '12px',
              ...(copied ? { background: 'green', color: '#fff', border: 'none' } : {})
            }}
            onClick={handleCopyHTML}
          >
            {copied ? (
              'Copied'
            ) : (
              <>
                <span style={{ fontSize: '16px', whiteSpace: 'nowrap' }}>
                  Icons by davooda.com
                </span>
                <img
                  src="/images/copy.svg"
                  alt="Copy"
                  style={{ width: '20px', height: '20px' }}
                />
              </>
            )}
          </div>

          {collection !== 'basic' && (
            <p style={{
              fontSize: '16px',
              color: '#333',
              marginTop: '40px', 
              lineHeight: '1.4',
              fontFamily: "'Poppins', sans-serif"
            }}>
              Don't want to add attribution? Purchase an SVG license that doesn't require it.
            </p>
          )}
        </div>

        <a
          href="#"
          style={{
            fontSize: '16px',
            color: '#0073e6',
            textDecoration: 'underline',
            fontFamily: "'Poppins', sans-serif",
            cursor: 'pointer',
            marginTop: 'auto'
          }}
          onClick={handleHowToAttribute}
        >
          How to attribute?
        </a>
      </div>

      <div style={{ display: 'none' }}>
        <a href={baseURL} target="_blank" rel="noopener">Icons</a> by <a href="https://davooda.com" target="_blank" rel="noopener">davooda.com</a>
      </div>
    </div>
  );
};

export default MakeaLinkPopup;